// Muted Notion-style pill colors, shared by the database table and the node
// detail panel so an app/schema/relation reads with the same color everywhere.

const PILL_COLORS = [
    { bg: 'rgba(140, 100, 180, 0.12)', color: '#7c5caa' },  // purple
    { bg: 'rgba(210, 130, 60, 0.12)', color: '#b87530' },    // orange
    { bg: 'rgba(70, 130, 180, 0.12)', color: '#3a7abf' },    // blue
    { bg: 'rgba(180, 80, 80, 0.12)', color: '#b35050' },     // red
    { bg: 'rgba(80, 160, 90, 0.12)', color: '#4a9a55' },     // green
    { bg: 'rgba(180, 160, 60, 0.12)', color: '#a09030' },    // yellow
    { bg: 'rgba(160, 100, 140, 0.12)', color: '#a06888' },   // pink
    { bg: 'rgba(100, 160, 160, 0.12)', color: '#5a9a9a' },   // teal
];

const KNOWN_PILL_COLORS = {
    'synapse': { bg: 'rgba(140, 100, 180, 0.15)', color: '#7c5caa' },
    'personas': { bg: 'rgba(210, 140, 60, 0.15)', color: '#b87530' },
    'concept': { bg: 'rgba(70, 130, 180, 0.15)', color: '#3a7abf' },
    'interception': { bg: 'rgba(80, 160, 90, 0.15)', color: '#4a9a55' },
    'videocall message': { bg: 'rgba(180, 80, 80, 0.15)', color: '#b35050' },
    'conversation rawfile artifact': { bg: 'rgba(100, 160, 160, 0.15)', color: '#5a9a9a' },
    'huddle audio track': { bg: 'rgba(160, 100, 140, 0.15)', color: '#a06888' },
};

export function getPillColor(name) {
    if (!name) return { bg: 'rgba(0,0,0,0.04)', color: 'var(--text-secondary)' };
    const known = KNOWN_PILL_COLORS[name.toLowerCase()];
    if (known) return known;
    // Deterministic hash so the same label always lands on the same color.
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = ((hash << 5) - hash + name.charCodeAt(i)) | 0;
    return PILL_COLORS[Math.abs(hash) % PILL_COLORS.length];
}
